<script lang="ts" setup>
import BrandCard from '~/components/cards/BrandCard.vue'
import ViewAllButton from '~/components/form-elements/ViewAllButton.vue'
import Page from '~/enums/page'
import type { BrandData } from '~/types/brands'

withDefaults(
  defineProps<{
    brandsData: BrandData[]
    showButton?: boolean
    title: string
  }>(),
  { showButton: true }
)

const brandsPath = Page.Brands
</script>

<template>
  <section v-if="brandsData.length">
    <div class="container">
      <Heading element="h2" :path="brandsPath" :title="title" title-class="h1">
        <template v-if="showButton" #buttons>
          <ViewAllButton title="Все бренды" @click="navigateTo(brandsPath)" />
        </template>
      </Heading>
    </div>

    <Carousel>
      <div class="-ml-2 flex md:-ml-4">
        <div
          v-for="x in brandsData"
          :key="x.id"
          class="flex-[0_0_23.076923%] cursor-pointer pl-2 md:flex-[0_0_16.666667%] md:pl-4 lg:flex-[0_0_12.5%]"
        >
          <BrandCard :brand-data="x" />
        </div>
      </div>
    </Carousel>
  </section>
</template>
